// extracted by mini-css-extract-plugin
module.exports = {"dialog":"FeedbackDialog_dialog_-Nn5T","footer":"FeedbackDialog_footer_1iz_V"};